<template>
  <v-card outlined class="fill-height">
    <div align="center">
      <div v-if="!chartData.length || noData" style="display: grid" class="py-3 subtitle-1 justify-center align-center">
        <span class="title"> {{ title }} </span>
        <span class="my-16 subtitle-2 font-weight-medium">  {{ $t('noData')}} </span>
      </div>
      <ejs-accumulationchart v-else
        ref="pie"
        :theme="theme"
        style="display: block"
        align="center"
        :title="title"
        :legendSettings="legendSettings"
        :tooltip="tooltip"
        :enableSmartLabels="enableSmartLabels"
        :enableAnimation="enableAnimation"
        :center="center"
        height="70%"
        width="100%"
      >
        <e-accumulation-series-collection>
          <e-accumulation-series
            :dataSource="filterChartData"
            :startAngle="startAngle"
            :endAngle="endAngle"
            :explodeOffset="explodeOffset"
            :explodeIndex="explodeIndex"
            :radius="radius"
            xName="x"
            yName="y"
            :dataLabel="dataLabel"
            name="Count"
            innerRadius="0%"
            explode="true"
            :emptyPointSettings='emptyPointSettings'
          >
          </e-accumulation-series>
        </e-accumulation-series-collection>
      </ejs-accumulationchart>
    </div>
  </v-card>
</template>
<style scoped>
.title {
  font-size: 15px !important;
}
</style>
<script>
import Vue from "vue";
import {
  AccumulationChartPlugin,
  AccumulationTooltip,
  PieSeries,
  AccumulationDataLabel,
  AccumulationLegend,
} from "@syncfusion/ej2-vue-charts";
import _ from "lodash";
import { toHoursAndMinutes } from "@/utils/util";
Vue.use(AccumulationChartPlugin);

let selectedTheme = location.hash.split("/")[1];

selectedTheme = selectedTheme ? selectedTheme : "Material";
let theme = (
  selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
).replace(/-dark/i, "Dark");

export default Vue.extend({
  props: {
    isActualTimeChart: {
      type: Boolean,
      default: false,
    },
    chartData: {
      type: Array,
      default: () => [],
    },
    props: {
      type: String,
      default: "agendaCategory",
    },
    title: String,
  },
  data: function () {
    return {
      noData: false,
      emptyPointSettings: { mode: 'Average', fill: 'lightgrey'},
      theme: theme,
      dataLabel: {
        visible: true,
        position: "Inside",
        name: "text",
        font: {
          fontWeight: "600",
        },
      },
      enableSmartLabels: true,
      enableAnimation: false,
      legendSettings: {
        visible: true,
        position: "Right",
        textWrap:'Wrap',
      },
      tooltip: {
        enable: true,
        header: "",
        format: "${point.x} : <b>${point.text}</b>",
      },
      startAngle: "0",
      endAngle: "360",
      radius: "70%",
      explodeOffset: "0%",
      explodeIndex: 0,
      center: { x: "50%", y: "50%" },
      //   title: "Count of Topics by Agenda Category",
    };
  },
  computed: {
    filterChartDataCopy() {
      const count = _.countBy(
        this.chartData.flatMap((value) => value[this.props])
      );
      const data = [];
      for (const key in count) {
        const obj = {
          x: key,
          y: count[key],
          text: this.toHoursAndMinutes(count[key]),
        };
        data.push(obj);
      }
      return data;
    },
    filterChartData() {
      const data = groupByTime(this.chartData, this.props);
      const timeAvg = [];

      data.forEach((value) => {
        const obj = {
          x: value[this.props],
          y: this.isActualTimeChart ? value.actualTime : value.scheduleTime,
          text: this.toHoursAndMinutes(this.isActualTimeChart ? value.actualTime : value.scheduleTime),
        };
        timeAvg.push(obj);
      });
      this.noData = timeAvg.every((item) => !item.y)
      return timeAvg;
    },
  },
  mounted() {
    const proxy = this;
    setTimeout(function () {
      if (proxy.$refs.pie && proxy.$refs.pie.ej2Instances) {
        proxy.$refs.pie.ej2Instances.refresh();
        proxy.$refs.pie.ej2Instances.removeSvg();
        proxy.$refs.pie.ej2Instances.refreshSeries();
        proxy.$refs.pie.ej2Instances.refreshChart();
      }
    }, 10);
  },
  provide: {
    accumulationchart: [
      AccumulationLegend,
      PieSeries,
      AccumulationTooltip,
      AccumulationDataLabel,
    ],
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.$refs.pie && this.$refs.pie.ej2Instances) {
        this.$refs.pie.ej2Instances.refresh();
        this.$refs.pie.ej2Instances.removeSvg();
        this.$refs.pie.ej2Instances.refreshSeries();
        this.$refs.pie.ej2Instances.refreshChart();
      }
    });
  },
  methods: {
    toHoursAndMinutes,
  },
});

const groupByTime = (arr = [], props) => {
  const map = {};
  let res = [];
  res = arr.reduce((acc, val, index) => {
    const { scheduleTime, actualTime } = val;
    const propsData = val[props];
    const { length: l } = acc;
    if (map.hasOwnProperty(propsData)) {
      acc[map[propsData]]["scheduleTime"] =
        acc[map[propsData]]["scheduleTime"] + Number(scheduleTime);
      acc[map[propsData]]["actualTime"] =
        acc[map[propsData]]["actualTime"] + Number(actualTime);
    } else {
      map[propsData] = l;
      acc.push({
        [props]: propsData,
        scheduleTime: Number(scheduleTime),
        actualTime: Number(actualTime),
      });
    }
    return acc;
  }, []);
  return res;
};
</script>